import { useSelector } from "react-redux";
import * as selectors from "../../store/personalization/selectors";
import { useTheme } from "../../config/emotion";
import { Colors } from "../../globalTypes/theme";

export const usePrimaryColor = () => useSelector(selectors.getPrimaryColor);
export const useSecondaryColor = () => useSelector(selectors.getSecondaryColor);
export const useBgColor = () => useSelector(selectors.getBgColor);

const useColors = (): Colors => useTheme().colors;

export default useColors;
